import{a as t}from"./chunk-RAAYCPUM.js";function c(...e){return t(d,e)}var d=(e,o)=>{let n={};for(let[a,y]of e.entries()){let r=o(y,a,e);r!==void 0&&(n[r]??=0,n[r]+=1)}return n};export{c as a};
